<ion-header *ngIf="!mailView"
            class="ion-no-shadow ion-no-border">
    <header-notifications></header-notifications>
    <ion-toolbar class="ion-hide-xl-up">
        <!-- <a (click)="routerExtService.back()"
           class="back-link">
            <svg-icon [applyClass]="true"
                      src="/assets/icons/ico-arrow.svg"></svg-icon>

        </a> -->
        <a *ngIf="plt.eventsCount > 1"
           (click)="plt.openEventMenu()"
           class="change-event">
            <svg-icon [applyClass]="true"
                      src="/assets/icons/change-event.svg"></svg-icon>
            <ion-badge *ngIf="plt.unreadOtherCount"
                       class="notification">
                {{ plt.unreadOtherCount }}
            </ion-badge>
        </a>
        <ion-title>{{ 'USER_SETTING_TITLE' | trns }}</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content [ngClass]="{'mail-view': mailView}">

    <app-out-link class="bottom-space"></app-out-link>

    <ng-container *ngIf="!loading">
        <div class="content-box">

            <div *ngIf="!mailView"
                 class="version">
                <!-- <ng-container *ngIf="userLang=='en'">
                    <a class="imprint"
                       href="https://www.congreet.com/en/imprint/"
                       target="_blank">{{ 'CUSTOM_IMPRESSUM' | trns }}</a>
                </ng-container>
                <ng-container *ngIf="userLang=='de'">
                    <a class="imprint"
                       href="https://www.congreet.com/de/impressum/"
                       target="_blank">{{ 'CUSTOM_IMPRESSUM' | trns }}</a>
                </ng-container> -->
                <ng-container *ngIf="event?.setting?.custom_imprint">
                    <span class="imprint"
                          (click)="openImprint($event)">{{ 'CUSTOM_IMPRESSUM' | trns }}</span>
                </ng-container>
                v{{ env.version }}
            </div>

            <div *ngIf="mailView"
                 class="event-detail">
                <h2> {{event.name}}</h2>
                <img img-logo
                     [src]="event.logo_url"
                     [alt]="event.name">
            </div>
            <h1 *ngIf="!mailView">{{ 'USER_SETTING_TITLE' | trns }}</h1>
            <h1 *ngIf="mailView">{{ 'USER_MAIL_SETTING_TITLE' | trns }}</h1>

            <div class="content-box-inner">
                <!-- <div class="content-header">

            </div> -->
                <div class="content-data">
                    <form method="get"
                          #f="ngForm"
                          role="form"
                          (ngSubmit)="save()"
                          class="form-horizontal">
                        <ng-container *ngIf="!mailView">
                            <h2>{{ 'USER_SETTING_SETTINGS_LANGUAGE' | trns }}</h2>
                            <ion-item>
                                <ion-label *ngIf="plt.sizeLg"
                                           position="stacked">
                                    {{ 'LANGUAGE' | trns }}
                                </ion-label>
                                <ion-label *ngIf="!plt.sizeLg"
                                           position="fixed">
                                    {{ 'LANGUAGE' | trns }}
                                </ion-label>
                                <ion-select *ngIf="!submit"
                                            [interface]="selectType"
                                            [interfaceOptions]="{cssClass:'not-overflow'}"
                                            [cancelText]="'BUTTON_CANCEL' |  translate"
                                            name="locale"
                                            id="lang-select"
                                            #locale="ngModel"
                                            [(ngModel)]="settings.locale">
                                    <ng-container *ngIf="!submit">
                                        <ion-select-option *ngFor="let lang of langs"
                                                           [value]="lang">
                                            {{ lang | uppercase | translate }}
                                        </ion-select-option>
                                    </ng-container>
                                    <ng-container *ngIf="submit">
                                        <ion-select-option>
                                            ...
                                        </ion-select-option>
                                    </ng-container>
                                </ion-select>
                            </ion-item>
                            <hr class="full" />
                        </ng-container>

                        <ion-grid *ngIf="plt.is('cordova')"
                                  class="ion-no-padding">
                            <h2>{{ 'USER_SETTING_SETTINGS_PUSH' | trns }}</h2>
                            <ion-row class="ion-no-padding">
                                <ion-col size="12"
                                         size-md="6"
                                         class="ion-no-padding ion-padding-end">
                                    <ion-item>
                                        <ion-label *ngIf="plt.sizeLg"
                                                   position="stacked">
                                            {{ 'USER_SETTING_MESSAGING_AND_APPOINTMENT' | trns }}
                                        </ion-label>
                                        <ion-label *ngIf="!plt.sizeLg"
                                                   position="fixed">
                                            {{ 'USER_SETTING_MESSAGING_AND_APPOINTMENT' | trns }}
                                        </ion-label>
                                        <ion-select *ngIf="!submit"
                                                    [interface]="selectType"
                                                    [cancelText]="'BUTTON_CANCEL' |  translate"
                                                    name="notify_messaging_interval_push"
                                                    #notify_interest_interval="ngModel"
                                                    [(ngModel)]="settings.notify_messaging_interval_push">
                                            <ng-container *ngIf="!submit">
                                                <ion-select-option *ngFor="let interval of settings.possibleIntervals"
                                                                   [value]="interval">
                                                    {{ interval | translate }}
                                                </ion-select-option>
                                            </ng-container>
                                            <ng-container *ngIf="submit">
                                                <ion-select-option>
                                                    ...
                                                </ion-select-option>
                                            </ng-container>
                                        </ion-select>
                                    </ion-item>
                                </ion-col>
                                <ion-col size="12"
                                         size-md="6"
                                         class="ion-no-padding">
                                    <small>{{ 'USER_SETTING_MESSAGING_HINT' | trns }}</small>
                                </ion-col>
                            </ion-row>
                            <ion-row *ngIf="event?.is_homepage_content_newsfeed"
                                     class="ion-no-padding">
                                <ion-col size="12"
                                         size-md="6"
                                         class="ion-no-padding ion-padding-end">
                                    <ion-item>
                                        <ion-label *ngIf="plt.sizeLg"
                                                   position="stacked">
                                            {{ 'USER_SETTING_NEWSFEED' | trns }}
                                        </ion-label>
                                        <ion-label *ngIf="!plt.sizeLg"
                                                   position="fixed">
                                            {{ 'USER_SETTING_NEWSFEED' | trns }}
                                        </ion-label>
                                        <ion-select *ngIf="!submit"
                                                    [interface]="selectType"
                                                    [cancelText]="'BUTTON_CANCEL' |  translate"
                                                    name="notify_newsfeed_interval_push"
                                                    #notify_interest_interval="ngModel"
                                                    [(ngModel)]="settings.notify_newsfeed_interval_push">
                                            <ng-container *ngIf="!submit">
                                                <ion-select-option *ngFor="let interval of settings.possibleIntervals"
                                                                   [value]="interval">
                                                    {{ interval | translate }}
                                                </ion-select-option>
                                            </ng-container>
                                            <ng-container *ngIf="submit">
                                                <ion-select-option>
                                                    ...
                                                </ion-select-option>
                                            </ng-container>
                                        </ion-select>
                                    </ion-item>
                                </ion-col>
                                <ion-col size="12"
                                         size-md="6"
                                         class="ion-no-padding">
                                    <small>{{ 'USER_SETTING_NEWSFEED_HINT' | trns }}</small>
                                </ion-col>
                            </ion-row>
                            <ion-row *ngIf="event?.marketplaces?.length > 0"
                                     class="ion-no-padding">
                                <ion-col size="12"
                                         size-md="6"
                                         class="ion-no-padding ion-padding-end">
                                    <ion-item>
                                        <ion-label *ngIf="plt.sizeLg"
                                                   position="stacked">
                                            {{ 'USER_SETTING_MARKETPLACE' | trns }}
                                        </ion-label>
                                        <ion-label *ngIf="!plt.sizeLg"
                                                   position="fixed">
                                            {{ 'USER_SETTING_MARKETPLACE' | trns }}
                                        </ion-label>
                                        <ion-select *ngIf="!submit"
                                                    [interface]="selectType"
                                                    [cancelText]="'BUTTON_CANCEL' |  translate"
                                                    name="notify_marketplace_interval_push"
                                                    #notify_interest_interval="ngModel"
                                                    [(ngModel)]="settings.notify_marketplace_interval_push">
                                            <ng-container *ngIf="!submit">
                                                <ion-select-option *ngFor="let interval of settings.possibleIntervals"
                                                                   [value]="interval">
                                                    {{ interval | translate }}
                                                </ion-select-option>
                                            </ng-container>
                                            <ng-container *ngIf="submit">
                                                <ion-select-option>
                                                    ...
                                                </ion-select-option>
                                            </ng-container>
                                        </ion-select>
                                    </ion-item>
                                </ion-col>
                                <ion-col size="12"
                                         size-md="6"
                                         class="ion-no-padding">
                                    <small>{{ 'USER_SETTING_MARKETPLACE_HINT' | trns }}</small>
                                </ion-col>
                            </ion-row>
                            <ion-row class="ion-no-padding">
                                <ion-col size="12"
                                         size-md="6"
                                         class="ion-no-padding ion-padding-end">
                                    <ion-item>
                                        <ion-label *ngIf="plt.sizeLg"
                                                   position="stacked">
                                            {{ 'USER_SETTING_PARTICIPANTS' | trns }}
                                        </ion-label>
                                        <ion-label *ngIf="!plt.sizeLg"
                                                   position="fixed">
                                            {{ 'USER_SETTING_PARTICIPANTS' | trns }}
                                        </ion-label>
                                        <ion-select *ngIf="!submit"
                                                    [interface]="selectType"
                                                    [cancelText]="'BUTTON_CANCEL' |  translate"
                                                    name="notify_interest_interval_push"
                                                    #notify_interest_interval="ngModel"
                                                    [(ngModel)]="settings.notify_interest_interval_push">
                                            <ng-container *ngIf="!submit">
                                                <ion-select-option *ngFor="let interval of settings.possibleIntervals"
                                                                   [value]="interval">
                                                    {{ interval | translate }}
                                                </ion-select-option>
                                            </ng-container>
                                            <ng-container *ngIf="submit">
                                                <ion-select-option>
                                                    ...
                                                </ion-select-option>
                                            </ng-container>
                                        </ion-select>
                                    </ion-item>
                                </ion-col>
                                <ion-col size="12"
                                         size-md="6"
                                         class="ion-no-padding">
                                    <small>{{ 'USER_SETTING_PARTICIPANTS_HINT' | trns }}</small>
                                </ion-col>
                            </ion-row>
                            <ion-row class="ion-no-padding">
                                <ion-col size="12"
                                         size-md="6"
                                         class="ion-no-padding ion-padding-end">
                                    <ion-item>
                                        <ion-label *ngIf="plt.sizeLg"
                                                   position="stacked">
                                            {{ 'USER_SETTING_KEYWORDS' | trns }}
                                        </ion-label>
                                        <ion-label *ngIf="!plt.sizeLg"
                                                   position="fixed">
                                            {{ 'USER_SETTING_KEYWORDS' | trns }}
                                        </ion-label>
                                        <ion-select *ngIf="!submit"
                                                    [interface]="selectType"
                                                    [cancelText]="'BUTTON_CANCEL' |  translate"
                                                    name="notify_keywords_interval_push"
                                                    #notify_keywords_interval="ngModel"
                                                    [(ngModel)]="settings.notify_keywords_interval_push">
                                            <ng-container *ngIf="!submit">
                                                <ion-select-option *ngFor="let interval of settings.possibleIntervals"
                                                                   [value]="interval">
                                                    {{ interval | translate }}
                                                </ion-select-option>
                                            </ng-container>
                                            <ng-container *ngIf="submit">
                                                <ion-select-option>
                                                    ...
                                                </ion-select-option>
                                            </ng-container>
                                        </ion-select>
                                    </ion-item>
                                </ion-col>
                                <ion-col size="12"
                                         size-md="6"
                                         class="ion-no-padding">
                                    <small>{{ 'USER_SETTING_KEYWORDS_HINT' | trns }}</small>
                                </ion-col>
                            </ion-row>
                            <ion-row class="ion-no-padding">
                                <ion-col size="12"
                                         size-md="6"
                                         class="ion-no-padding ion-padding-end">
                                    <ion-item>
                                        <ion-label *ngIf="plt.sizeLg"
                                                   position="stacked">
                                            {{ 'USER_SETTING_MATCHING' | trns }}
                                        </ion-label>
                                        <ion-label *ngIf="!plt.sizeLg"
                                                   position="fixed">
                                            {{ 'USER_SETTING_MATCHING' | trns }}
                                        </ion-label>
                                        <ion-select *ngIf="!submit"
                                                    [interface]="selectType"
                                                    [cancelText]="'BUTTON_CANCEL' |  translate"
                                                    class="form-control"
                                                    name="notify_matching_interval_push"
                                                    #notify_matching_interval="ngModel"
                                                    [(ngModel)]="settings.notify_matching_interval_push">
                                            <ng-container *ngIf="!submit">
                                                <ion-select-option *ngFor="let interval of settings.possibleIntervals"
                                                                   [value]="interval">
                                                    {{ interval | translate }}
                                                </ion-select-option>
                                            </ng-container>
                                            <ng-container *ngIf="submit">
                                                <ion-select-option>
                                                    ...
                                                </ion-select-option>
                                            </ng-container>
                                        </ion-select>
                                    </ion-item>
                                </ion-col>
                                <ion-col size="12"
                                         size-md="6"
                                         class="ion-no-padding">
                                    <small>{{ 'USER_SETTING_MATCHING_HINT_PUSH' | trns }}</small>
                                </ion-col>
                            </ion-row>
                            <ion-row class="ion-no-padding">
                                <ion-col size="12"
                                         size-md="6"
                                         class="ion-no-padding ion-padding-end">
                                    <ion-item>
                                        <ion-label *ngIf="plt.sizeLg"
                                                   position="stacked">
                                            {{ 'USER_SETTING_CHAT_GROUP' | trns }}
                                        </ion-label>
                                        <ion-label *ngIf="!plt.sizeLg"
                                                   position="fixed">
                                            {{ 'USER_SETTING_CHAT_GROUP' | trns }}
                                        </ion-label>
                                        <ion-select *ngIf="!submit"
                                                    [interface]="selectType"
                                                    [cancelText]="'BUTTON_CANCEL' |  translate"
                                                    class="form-control"
                                                    name="notify_chat_group_interval_push"
                                                    #notify_matching_interval="ngModel"
                                                    [(ngModel)]="settings.notify_chat_group_interval_push">
                                            <ng-container *ngIf="!submit">
                                                <ion-select-option *ngFor="let interval of settings.possibleIntervals"
                                                                   [value]="interval">
                                                    {{ interval | translate }}
                                                </ion-select-option>
                                            </ng-container>
                                            <ng-container *ngIf="submit">
                                                <ion-select-option>
                                                    ...
                                                </ion-select-option>
                                            </ng-container>
                                        </ion-select>
                                    </ion-item>
                                </ion-col>
                                <ion-col size="12"
                                         size-md="6"
                                         class="ion-no-padding">
                                    <small>{{ 'USER_SETTING_CHAT_GROUP_HINT_PUSH' | trns }}</small>
                                </ion-col>
                            </ion-row>
                            <br />
                            <hr class="full" />
                        </ion-grid>

                        <ion-grid class="ion-no-padding email-settings">
                            <h2>{{ 'USER_SETTING_SETTINGS_EMAIL' | trns }}</h2>
                            <p *ngIf="user.email_blacklisted"
                               [innerHtml]="'USER_EMAIL_BLACKLISTED'| translate:{'supportEmail': 'SUPPORT_EMAIL'|translate}">
                            </p>
                            <ng-container *ngIf="!user.email_blacklisted">
                                <ion-row class="ion-no-padding">
                                    <ion-col size="12"
                                             size-md="6"
                                             class="ion-no-padding ion-padding-end">
                                        <ion-item>
                                            <ion-label *ngIf="plt.sizeLg"
                                                       position="stacked">
                                                {{ 'USER_SETTING_MESSAGING_AND_APPOINTMENT' | trns }}
                                            </ion-label>
                                            <ion-label *ngIf="!plt.sizeLg"
                                                       position="fixed">
                                                {{ 'USER_SETTING_MESSAGING_AND_APPOINTMENT' | trns }}
                                            </ion-label>
                                            <ion-select *ngIf="!submit"
                                                        [interface]="selectType"
                                                        [cancelText]="'BUTTON_CANCEL' |  translate"
                                                        name="notify_messaging_interval"
                                                        id="messaging-select"
                                                        #notify_interest_interval="ngModel"
                                                        [(ngModel)]="settings.notify_messaging_interval">
                                                <ng-container *ngIf="!submit">
                                                    <ion-select-option *ngFor="let interval of settings.possibleIntervals"
                                                                       [value]="interval">
                                                        {{ interval | translate }}
                                                    </ion-select-option>
                                                </ng-container>
                                                <ng-container *ngIf="submit">
                                                    <ion-select-option>
                                                        ...
                                                    </ion-select-option>
                                                </ng-container>
                                            </ion-select>
                                        </ion-item>
                                    </ion-col>
                                    <ion-col size="12"
                                             size-md="6"
                                             class="ion-no-padding">
                                        <small>{{ 'USER_SETTING_MESSAGING_HINT' | trns }}</small>
                                    </ion-col>
                                </ion-row>
                                <ion-row *ngIf="event?.is_homepage_content_newsfeed"
                                         class="ion-no-padding">
                                    <ion-col size="12"
                                             size-md="6"
                                             class="ion-no-padding ion-padding-end">
                                        <ion-item>
                                            <ion-label *ngIf="plt.sizeLg"
                                                       position="stacked">
                                                {{ 'USER_SETTING_NEWSFEED' | trns }}
                                            </ion-label>
                                            <ion-label *ngIf="!plt.sizeLg"
                                                       position="fixed">
                                                {{ 'USER_SETTING_NEWSFEED' | trns }}
                                            </ion-label>
                                            <ion-select *ngIf="!submit"
                                                        [interface]="selectType"
                                                        [cancelText]="'BUTTON_CANCEL' |  translate"
                                                        name="notify_newsfeed_interval"
                                                        #notify_interest_interval="ngModel"
                                                        [(ngModel)]="settings.notify_newsfeed_interval">
                                                <ng-container *ngIf="!submit">
                                                    <ion-select-option *ngFor="let interval of settings.possibleIntervals"
                                                                       [value]="interval">
                                                        {{ interval | translate }}
                                                    </ion-select-option>
                                                </ng-container>
                                                <ng-container *ngIf="submit">
                                                    <ion-select-option>
                                                        ...
                                                    </ion-select-option>
                                                </ng-container>
                                            </ion-select>
                                        </ion-item>
                                    </ion-col>
                                    <ion-col size="12"
                                             size-md="6"
                                             class="ion-no-padding">
                                        <small>{{ 'USER_SETTING_NEWSFEED_HINT' | trns }}</small>
                                    </ion-col>
                                </ion-row>
                                <ion-row *ngIf="event?.marketplaces?.length > 0"
                                         class="ion-no-padding">
                                    <ion-col size="12"
                                             size-md="6"
                                             class="ion-no-padding ion-padding-end">
                                        <ion-item>
                                            <ion-label *ngIf="plt.sizeLg"
                                                       position="stacked">
                                                {{ 'USER_SETTING_MARKETPLACE' | trns }}
                                            </ion-label>
                                            <ion-label *ngIf="!plt.sizeLg"
                                                       position="fixed">
                                                {{ 'USER_SETTING_MARKETPLACE' | trns }}
                                            </ion-label>
                                            <ion-select *ngIf="!submit"
                                                        [interface]="selectType"
                                                        [cancelText]="'BUTTON_CANCEL' |  translate"
                                                        name="notify_marketplace_interval"
                                                        #notify_interest_interval="ngModel"
                                                        [(ngModel)]="settings.notify_marketplace_interval">
                                                <ng-container *ngIf="!submit">
                                                    <ion-select-option *ngFor="let interval of settings.possibleIntervals"
                                                                       [value]="interval">
                                                        {{ interval | translate }}
                                                    </ion-select-option>
                                                </ng-container>
                                                <ng-container *ngIf="submit">
                                                    <ion-select-option>
                                                        ...
                                                    </ion-select-option>
                                                </ng-container>
                                            </ion-select>
                                        </ion-item>
                                    </ion-col>
                                    <ion-col size="12"
                                             size-md="6"
                                             class="ion-no-padding">
                                        <small>{{ 'USER_SETTING_MARKETPLACE_HINT' | trns }}</small>
                                    </ion-col>
                                </ion-row>
                                <ion-row class="ion-no-padding">
                                    <ion-col size="12"
                                             size-md="6"
                                             class="ion-no-padding ion-padding-end">
                                        <ion-item>
                                            <ion-label *ngIf="plt.sizeLg"
                                                       position="stacked">
                                                {{ 'USER_SETTING_PARTICIPANTS' | trns }}
                                            </ion-label>
                                            <ion-label *ngIf="!plt.sizeLg"
                                                       position="fixed">
                                                {{ 'USER_SETTING_PARTICIPANTS' | trns }}
                                            </ion-label>
                                            <ion-select *ngIf="!submit"
                                                        [interface]="selectType"
                                                        [cancelText]="'BUTTON_CANCEL' |  translate"
                                                        name="notify_interest_interval"
                                                        #notify_interest_interval="ngModel"
                                                        [(ngModel)]="settings.notify_interest_interval">
                                                <ng-container *ngIf="!submit">
                                                    <ion-select-option *ngFor="let interval of settings.possibleIntervals"
                                                                       [value]="interval">
                                                        {{ interval | translate }}
                                                    </ion-select-option>
                                                </ng-container>
                                                <ng-container *ngIf="submit">
                                                    <ion-select-option>
                                                        ...
                                                    </ion-select-option>
                                                </ng-container>
                                            </ion-select>
                                        </ion-item>
                                    </ion-col>
                                    <ion-col size="12"
                                             size-md="6"
                                             class="ion-no-padding">
                                        <small>{{ 'USER_SETTING_PARTICIPANTS_HINT' | trns }}</small>
                                    </ion-col>
                                </ion-row>
                                <ion-row class="ion-no-padding">
                                    <ion-col size="12"
                                             size-md="6"
                                             class="ion-no-padding ion-padding-end">
                                        <ion-item>
                                            <ion-label *ngIf="plt.sizeLg"
                                                       position="stacked">
                                                {{ 'USER_SETTING_KEYWORDS' | trns }}
                                            </ion-label>
                                            <ion-label *ngIf="!plt.sizeLg"
                                                       position="fixed">
                                                {{ 'USER_SETTING_KEYWORDS' | trns }}
                                            </ion-label>
                                            <ion-select *ngIf="!submit"
                                                        [interface]="selectType"
                                                        [cancelText]="'BUTTON_CANCEL' |  translate"
                                                        name="notify_keywords_interval"
                                                        #notify_keywords_interval="ngModel"
                                                        [(ngModel)]="settings.notify_keywords_interval">
                                                <ng-container *ngIf="!submit">
                                                    <ion-select-option *ngFor="let interval of settings.possibleIntervals"
                                                                       [value]="interval">
                                                        {{ interval | translate }}
                                                    </ion-select-option>
                                                </ng-container>
                                                <ng-container *ngIf="submit">
                                                    <ion-select-option>
                                                        ...
                                                    </ion-select-option>
                                                </ng-container>
                                            </ion-select>
                                        </ion-item>
                                    </ion-col>
                                    <ion-col size="12"
                                             size-md="6"
                                             class="ion-no-padding">
                                        <small>{{ 'USER_SETTING_KEYWORDS_HINT' | trns }}</small>
                                    </ion-col>
                                </ion-row>
                                <ion-row class="ion-no-padding">
                                    <ion-col size="12"
                                             size-md="6"
                                             class="ion-no-padding ion-padding-end">
                                        <ion-item>
                                            <ion-label *ngIf="plt.sizeLg"
                                                       position="stacked">
                                                {{ 'USER_SETTING_MATCHING' | trns }}
                                            </ion-label>
                                            <ion-label *ngIf="!plt.sizeLg"
                                                       position="fixed">
                                                {{ 'USER_SETTING_MATCHING' | trns }}
                                            </ion-label>
                                            <ion-select *ngIf="!submit"
                                                        [interface]="selectType"
                                                        [cancelText]="'BUTTON_CANCEL' |  translate"
                                                        class="form-control"
                                                        name="notify_matching_interval"
                                                        #notify_matching_interval="ngModel"
                                                        [(ngModel)]="settings.notify_matching_interval">
                                                <ng-container *ngIf="!submit">
                                                    <ion-select-option *ngFor="let interval of settings.possibleIntervals"
                                                                       [value]="interval">
                                                        {{ interval | translate }}
                                                    </ion-select-option>
                                                </ng-container>
                                                <ng-container *ngIf="submit">
                                                    <ion-select-option>
                                                        ...
                                                    </ion-select-option>
                                                </ng-container>
                                            </ion-select>
                                        </ion-item>
                                    </ion-col>
                                    <ion-col size="12"
                                             size-md="6"
                                             class="ion-no-padding">
                                        <small>{{ 'USER_SETTING_MATCHING_HINT' | trns }}</small>
                                    </ion-col>
                                </ion-row>

                                <ion-row class="ion-no-padding">
                                    <ion-col size="12"
                                             size-md="6"
                                             class="ion-no-padding ion-padding-end">
                                        <ion-item>
                                            <ion-label *ngIf="plt.sizeLg"
                                                       position="stacked">
                                                {{ 'USER_SETTING_CHAT_GROUP' | trns }}
                                            </ion-label>
                                            <ion-label *ngIf="!plt.sizeLg"
                                                       position="fixed">
                                                {{ 'USER_SETTING_CHAT_GROUP' | trns }}
                                            </ion-label>
                                            <ion-select *ngIf="!submit"
                                                        [interface]="selectType"
                                                        [cancelText]="'BUTTON_CANCEL' |  translate"
                                                        class="form-control"
                                                        name="notify_chat_group_interval"
                                                        #notify_matching_interval="ngModel"
                                                        [(ngModel)]="settings.notify_chat_group_interval">
                                                <ng-container *ngIf="!submit">
                                                    <ion-select-option *ngFor="let interval of settings.possibleIntervals"
                                                                       [value]="interval">
                                                        {{ interval | translate }}
                                                    </ion-select-option>
                                                </ng-container>
                                                <ng-container *ngIf="submit">
                                                    <ion-select-option>
                                                        ...
                                                    </ion-select-option>
                                                </ng-container>
                                            </ion-select>
                                        </ion-item>
                                    </ion-col>
                                    <ion-col size="12"
                                             size-md="6"
                                             class="ion-no-padding">
                                        <small>{{ 'USER_SETTING_CHAT_GROUP_HINT' | trns }}</small>
                                    </ion-col>
                                </ion-row>
                            </ng-container>
                        </ion-grid>

                        <ng-container *ngIf="!plt.hideSettingsPasswordReset && !mailView">
                            <hr class="full" />
                            <h2>{{ 'PROFILE_CHANGE_PASSWORD' | translate }}</h2>

                            <ion-grid class="ion-no-padding">
                                <ion-row>
                                    <ion-col size="12"
                                             size-md="6"
                                             class="ion-no-padding ion-padding-end">
                                        <ion-item [ngClass]="{ 'has-error': validate && validationErrors['old_password'] }">
                                            <ion-label *ngIf="plt.sizeLg"
                                                       position="stacked">
                                                {{ 'PROFILE_OLD_PASSWORD' | translate }}
                                            </ion-label>
                                            <ion-label *ngIf="!plt.sizeLg"
                                                       position="fixed">
                                                {{ 'PROFILE_OLD_PASSWORD' | translate }}
                                            </ion-label>
                                            <ion-input type="password"
                                                       placeholder="{{ 'OLD_PASSWORD_PLACEHOLDER' | translate }}"
                                                       name="old_password"
                                                       inputmode="password"
                                                       spellcheck="false"
                                                       autocapitalize="off"
                                                       autocomplete="off"
                                                       #old_password="ngModel"
                                                       [(ngModel)]="user.old_password">
                                            </ion-input>
                                        </ion-item>
                                        <span *ngIf="validate && validationErrors['old_password']"
                                              class="error-message">
                                            {{ validationErrors['old_password'] }}
                                        </span>
                                    </ion-col>
                                </ion-row>
                                <ion-row>
                                    <ion-col size="12"
                                             size-md="6"
                                             class="ion-no-padding ion-padding-end">
                                        <ion-item [ngClass]="{ 'has-error': validate && validationErrors['new_password'] }">
                                            <ion-label *ngIf="plt.sizeLg"
                                                       position="stacked">
                                                {{ 'PROFILE_NEW_PASSWORD' | translate }}
                                            </ion-label>
                                            <ion-label *ngIf="!plt.sizeLg"
                                                       position="fixed">
                                                {{ 'PROFILE_NEW_PASSWORD' | translate }}
                                            </ion-label>
                                            <ion-input type="password"
                                                       placeholder="{{ 'NEW_PASSWORD_PLACEHOLDER' | translate }}"
                                                       name="new_password"
                                                       inputmode="password"
                                                       spellcheck="false"
                                                       autocapitalize="off"
                                                       #new_password="ngModel"
                                                       [(ngModel)]="user.new_password">
                                            </ion-input>
                                        </ion-item>
                                        <span *ngIf="validate && validationErrors['new_password']"
                                              class="error-message">
                                            {{ validationErrors['new_password'] }}
                                        </span>
                                    </ion-col>
                                    <ion-col size="12"
                                             size-md="6"
                                             class="ion-no-padding ion-padding-start">
                                        <ion-item [ngClass]="{ 'has-error': validate && validationErrors['new_password_confirmation'] }">
                                            <ion-label *ngIf="plt.sizeLg"
                                                       position="stacked">
                                                {{ 'PROFILE_REPEAT_PASSWORD' | translate }}
                                            </ion-label>
                                            <ion-label *ngIf="!plt.sizeLg"
                                                       position="fixed">
                                                {{ 'PROFILE_REPEAT_PASSWORD' | translate }}
                                            </ion-label>
                                            <ion-input type="password"
                                                       placeholder="{{ 'NEW_PASSWORD_CONFIRMATION_PLACEHOLDER' | translate }}"
                                                       name="new_password_confirmation"
                                                       inputmode="password"
                                                       spellcheck="false"
                                                       autocapitalize="off"
                                                       #new_password_confirmation="ngModel"
                                                       [(ngModel)]="user.new_password_confirmation">
                                            </ion-input>
                                        </ion-item>
                                        <span *ngIf="validate && validationErrors['new_password_confirmation']"
                                              class="error-message">
                                            {{ validationErrors['new_password_confirmation'] | translate }}
                                        </span>
                                    </ion-col>
                                </ion-row>
                            </ion-grid>
                        </ng-container>

                    </form>
                </div>
                <div class="content-footer">
                    <ion-grid class="ion-no-padding">
                        <ion-row>
                            <ion-col size="12"
                                     size-sm="3"
                                     class="ion-no-padding ion-align-self-start">
                                <ion-button *ngIf="!mailView"
                                            [ngClass]="{'btn-close':plt.sizeSm, 'clear':!plt.sizeSm}"
                                            fill="clear"
                                            color="secondary"
                                            [routerDirection]="'root'"
                                            [routerLink]="[plt.defaultLink + '/home/info/matching']">
                                    {{ 'BUTTON_CANCEL' | trns }}
                                </ion-button>
                            </ion-col>
                            <ion-col size="12"
                                     size-sm="9"
                                     class="ion-no-padding">
                                <ion-row class="ion-no-padding ion-align-items-center">
                                    <ion-col size="12"
                                             size-sm="9"
                                             class="ion-no-padding">
                                        <ion-item *ngIf="!mailView"
                                                  class="global ion-no-padding">
                                            <ion-checkbox slot="start"
                                                          [(ngModel)]="settings.set_global"></ion-checkbox>
                                            <ion-label *ngIf="!event?.is_community">{{ 'USER_SETTING_SET_GLOBAL' | trns }}</ion-label>
                                            <ion-label *ngIf="event?.is_community">{{ 'USER_SETTING_SET_GLOBAL_COMMUNITY' | trns }}</ion-label>
                                        </ion-item>
                                    </ion-col>
                                    <ion-col size="12"
                                             size-sm="3"
                                             class="ion-no-padding ion-text-right">
                                        <ion-button color="primary"
                                                    id="setting-save-button"
                                                    [disabled]="submit"
                                                    (click)="save(f.form.valid)">
                                            {{ 'BUTTON_SAVE' | trns }}
                                        </ion-button>
                                    </ion-col>
                                </ion-row>
                            </ion-col>
                        </ion-row>
                    </ion-grid>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="loading">
        <div class="content-centered-column">
            <div class="content-centered-row">
                <ion-spinner></ion-spinner>
            </div>
        </div>
    </ng-container>
</ion-content>